import React from "react";
import { AutoBind } from "../../../rule-engine-core/Common/AutoBind";
import { CollapseIcon } from "../../../CommonUI/Icon/CollapseIcon";
import { DeleteGrayIcon } from "../../../CommonUI/Icon/DeleteGrayIcon";
import { DragIcon } from "../../../CommonUI/Icon/DragIcon";
import { EditStackLightIcon } from "../../../CommonUI/Icon/EditStackLightIcon";
import { ExpandGrayIcon } from "../../../CommonUI/Icon/ExpandGrayIcon";
import { BaseSequenceActions } from "../BaseSequenceActions";
import { StyledIconButton } from "../CommonStyles";

export class RenderSequenceActions extends BaseSequenceActions {
    @AutoBind
    onToggleIsCollapsed(event: React.MouseEvent<HTMLDivElement>) {
        event.stopPropagation();
        this.props.sequence.isCollapsed = !this.props.sequence.isCollapsed;
    }

    render() {
        const sequence = this.props.sequence;
        return (
            <>
                <StyledIconButton>
                    <EditStackLightIcon />
                </StyledIconButton>
                {sequence.isNormal && !sequence.isPrimary && (
                    <StyledIconButton
                        data-testid={`${sequence._id}-btn-delete`}
                        onClick={this.onDeleteSequence}
                    >
                        <DeleteGrayIcon />
                    </StyledIconButton>
                )}
                <StyledIconButton
                    onClick={this.onToggleIsCollapsed}
                    data-testid={`${sequence._id}_btn-collapse`}
                >
                    {sequence.isCollapsed ? <ExpandGrayIcon /> : <CollapseIcon />}
                </StyledIconButton>
                {!sequence.isPrimary && sequence.isNormal && (
                    <StyledIconButton className="stack-move">
                        <DragIcon />
                    </StyledIconButton>
                )}
            </>
        );
    }
}
